module.exports = __webpack_public_path__ + "img/company_icon.a2345929.png";